$(document).ready(function() {
  $(".cross_icon, .search.mobile").hide();
  $(".search_icon").click(function(e) {
    e.stopPropagation();
    $(".search.mobile").fadeIn();
    $(".search_icon").fadeOut(function() {
      $(".cross_icon").fadeIn();
    });
  });
  $(".cross_icon").click(function(e) {
    e.stopPropagation(); 
    $(".search.mobile").fadeOut();

    $(".cross_icon").fadeOut(function() {
      $(".search_icon").fadeIn();
    });
  });
  $(document).on("click", function(e) {
    if (!$(e.target).closest(".search_bar_mobo").length) {
      $(".search.mobile").fadeOut();
      $(".cross_icon").fadeOut(function() {
        $(".search_icon").fadeIn();
      });
    }
  });
});




const targetText = "100% Money-Back Guarantee";

document.querySelectorAll("p").forEach((p) => {
  if (p.textContent.includes(targetText)) {
    const next = p.nextElementSibling;

    // Create a wrapper div with your desired inline styles
    const wrapper = document.createElement("div");
    wrapper.style.background = "#F3F3ED";
    wrapper.style.padding = "10px";

    // Insert the wrapper before the <p>
    p.parentNode.insertBefore(wrapper, p);

    // Move <p> into the wrapper
    wrapper.appendChild(p);

    // Move next sibling (e.g. <div>) into the wrapper
    if (next) wrapper.appendChild(next);
  }
});

